import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Marks the canvas mount of a 3D sub-viewport. The world's portal mounts the same children, so a
 * nested sub-viewport, which both workspaces mount, must draw in the world's mount alone.
 */
import { createContext, useContext } from 'react';
const CanvasOverWorldScope = createContext(false);
CanvasOverWorldScope.displayName = 'CanvasOverWorldScope';
export function CanvasOverWorldScopeProvider({ children }) {
    return _jsx(CanvasOverWorldScope.Provider, { value: true, children: children });
}
export function useInCanvasOverWorld() {
    return useContext(CanvasOverWorldScope);
}
//# sourceMappingURL=canvasOverWorldScope.js.map